import { DbUpdateReceiptCheckItem } from "../../../data/usecases/update-receipt-check-item";
import { UpdateReceiptCheckItem } from "../../../domain/usecases/update-receipt-check-item";
import { makeAuthorizeHttpClientDecorator } from "../decorators";
import { makeApiUrl } from "../http";

export const makeDbUpdateReceiptCheckItem = (): UpdateReceiptCheckItem =>
  new DbUpdateReceiptCheckItem(
    makeApiUrl("/receipt-check-item"),
    makeAuthorizeHttpClientDecorator()
  );
